<div class="relative text-platform flex justify-center">
  <div class="page-container">
    <div class="relative text-platform">
      <div class="h-32 md:h-40"></div>
      <div class="text-5xl sm:text[4rem] lg:text-[5rem] font-bold mb-12">Hey {{ givenName() }}!</div>
      <div class="mb-5">
        <div class="font-semibold text-xl lg:text-3xl mb-4">Aktive Losungen</div>
        @if (drawUserState.isLoading()) {
          <ticketing-loading-indicator />
        } @else if (drawUserState.isError()) {
          <div>
            Beim Abrufen der Losungen ist ein Fehler aufgetreten. Bitte warte einen Moment und versuche es dann erneut.
          </div>
        } @else {
          @if (currentDraws().length > 0) {
            <div class="grid lg:grid-cols-2 gap-4">
              @for (draw of currentDraws(); track draw.id) {
                <ticketing-customer-draw-item [draw]="draw" />
              }
            </div>
          } @else {
            <div class="opacity-50">Momentan gibt es keine aktiven Losungen.</div>
          }
        }

        @if (pastDraws().length > 0) {
          <div class="h-12"></div>
          <div class="font-semibold text-xl lg:text-3xl mb-4">Vergangene Losungen</div>
          <div class="grid lg:grid-cols-2 gap-4">
            @for (draw of pastDraws(); track draw.id) {
              <ticketing-customer-draw-item [draw]="draw" />
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
